import { useEffect } from "react";

import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { useStateContext } from "../../../context/AppContext";
import "./PrivacyPolicy.css";

export default function PrivacyPolicy() {
  const { dark } = useStateContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <div>
        <div className="privacy-policy-main">
          <h1 style={{ marginBottom: "2rem" }}>
            <span style={{ color: dark }}>PRIVACY</span> POLICY
          </h1>
          <p>
            At Sparkix Technologies, we value your privacy and are committed to
            protecting your personal information. This Privacy Policy outlines
            how we collect, use, and safeguard the data you provide to us
            through our website, forms, and advertising platforms.
          </p>

          <h3 style={{ margin: "2rem 0 1rem" }}>1. Information We Collect</h3>
          <p>We may collect the following types of information:</p>
          <p>• Name</p>
          <p>• Email address</p>
          <p>• Phone number</p>
          <p>• Company or organization name</p>
          <p>• Project-related details or inquiries</p>
          <p>
            This information is collected when you submit a form on our website
            or through one of our advertisements.
          </p>

          <h3 style={{ margin: "2rem 0 1rem" }}>
            2. How We Use Your Information
          </h3>
          <p>The information you provide is used solely for the purpose of:</p>
          <p>• Contacting you regarding your inquiry or project</p>
          <p>• Providing you with relevant service information or proposals</p>
          <p>• Improving our communication and service offerings</p>
          <p>
            We do not sell, rent, or share your personal data with third parties
            for marketing purposes.
          </p>

          <h3 style={{ margin: "2rem 0 1rem" }}>3. Data Security</h3>
          <p>
            We take reasonable and appropriate measures to protect your personal
            data from unauthorized access, alteration, disclosure, or
            destruction.
          </p>

          <h3 style={{ margin: "2rem 0 1rem" }}>4. Third-Party Platforms</h3>
          <p>
            Our advertising and lead collection may be conducted through
            third-party platforms such as Meta (Facebook and Instagram). Any
            data submitted through these platforms is also subject to their
            respective privacy policies.
          </p>

          <h3 style={{ margin: "2rem 0 1rem" }}>5. Your Rights</h3>
          <p>You have the right to:</p>
          <p>• Request access to your personal data</p>
          <p>• Request correction or deletion of your data</p>
          <p>• Withdraw consent at any time</p>
          <p>
            To exercise these rights, please contact us at&nbsp;
            <a href="mailto:contact@sparkixtech.com">contact@sparkixtech.com</a>
          </p>

          <h3 style={{ margin: "2rem 0 1rem" }}>6. Updates to This Policy</h3>
          <p>
            We may update this Privacy Policy from time to time. All changes
            will be posted on this page with an updated revision date.
          </p>
          <p>
            <strong>Effective Date: December 10, 2023</strong>
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}
